'use client';

import { createContext, useContext } from 'react';

/**
 * True inside the Labs arrival layout, so the sign-up form can drop its generic heading (the layout
 * already shows one above the card) without learning anything else about the arrival. Absent
 * everywhere else, which is what keeps ordinary sign-up traffic byte-for-byte unchanged.
 */
export const LabsArrivalContext = createContext(false);

export function useIsLabsArrival(): boolean {
  return useContext(LabsArrivalContext);
}
